import { forwardRef } from "react";

import Icon from "@/components/Icon";
import RawCheckIcon from "./RawCheckIcon.svg.jsx";

const CheckIcon = forwardRef((props, ref) => {
  return <Icon ref={ref} SvgComponent={RawCheckIcon} {...props} />;
});

export default CheckIcon;
